// extracted by mini-css-extract-plugin
module.exports = {"contraStrategy":"aceStrategy_contraStrategy__Dpf2e"};